export function openUrlWithPost(url, data) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = '_blank';
    form.style.display = 'none';
    form.acceptCharset = 'UTF-8';
    if (!isNullOrUndefined(data)) {
        Object.entries(data).forEach(([name, value]) => {
            if (isNullOrUndefined(value)) {
                return;
            }
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = String(value);
            form.appendChild(input);
        });
    }
    document.body.appendChild(form);
    form.submit();
    form.remove();
}
